// localStorage keys used by mock mode (safe to import from app code: no dependencies).
export const MOCK_SESSION_KEY = "lumen-admin-mock-session";
export const MOCK_OPS_KEY = "lumen-admin-mock-ops";

/** Forget mock mutations and the mock session, back to the deterministic seed. */
export function clearMockStorage() {
  try {
    localStorage.removeItem(MOCK_OPS_KEY);
    localStorage.removeItem(MOCK_SESSION_KEY);
  } catch {
    // storage unavailable: nothing persisted anyway
  }
}
